import BDI_Group from '@/components/pages/case/BDI_Group';


export default [
    {
        name: 'BDI_Group',
        path: '/case/BDI_Group',
        component: BDI_Group
    }
];



// WEBPACK FOOTER //
// ./src/router/case/case.js